import React, { useState, useEffect } from "react";
import AuthRouter from "./authRouter";
import AdminRouter from "./adminRouter";
import AuthApi from "../api/authApi";
import { Cookies } from "react-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import CoupleRouter from "./coupleRouter";
import type { LoveStrongUser } from "../types/api";
import { getAuthUser } from "../hooks/useAuthUser";
import { authClient } from "../auth/authClient";
import {
  beginLogout,
  clearAuthProfileCookies,
  getSessionCookieOptions,
  isLoggingOut,
} from "../utils/authSession";

const IndexRouter: React.FC = () => {
  const cookies = new Cookies();
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const checkFunciton = (): string | false => {
    const data = getAuthUser<LoveStrongUser>();
    if (data && data.userRole) {
      return data.userRole;
    }
    return false;
  };

  const updateuser = (data: string): void => {
    setUserRole(data);
  };

  const logoutUser = async (): Promise<void> => {
    const user = cookies.get("LoveStrongUser");
    beginLogout();
    setUserRole("");
    clearAuthProfileCookies();
    navigate("/login", { replace: true });
    try {
      await authClient.signOut({});
    } catch {
      /* Better Auth session may already be gone */
    }
    try {
      const authApi = new AuthApi();
      await authApi.Logout({
        userId: user?.id || null,
        userRole: user?.userRole || null,
        userName: user?.userName || null,
      });
    } catch {
      /* local session is already cleared */
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const isLoggedIn = getAuthUser();
    if (
      !isLoggedIn &&
      (currentPath.startsWith("/retreat-registrations") ||
        currentPath === "/retreat-registrations")
    ) {
      const redirectUrl = encodeURIComponent(currentPath);
      navigate(`/login?redirect=${redirectUrl}`);
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (isLoggingOut()) return;
    const profile = getAuthUser<LoveStrongUser>();
    if (!profile?.userRole) return;
    if (location.pathname === "/login" || location.pathname === "/set-password") {
      return;
    }

    let cancelled = false;
    const authApi = new AuthApi();
    authApi
      .completeSession({ silent: true })
      .then((res: any) => {
        if (cancelled || isLoggingOut()) return;
        if (!res?.success || !res.data?.userRole) {
          beginLogout();
          setUserRole("");
          clearAuthProfileCookies();
          if (location.pathname !== "/login") {
            navigate("/login", { replace: true });
          }
          return;
        }
        const profile = { ...res.data };
        delete profile.jwtToken;
        cookies.set("LoveStrongUser", profile, getSessionCookieOptions(true));
        cookies.remove("LoveStrongToken", { path: "/" });
        setUserRole(res.data.userRole);
      })
      .catch(() => {
        /* keep cached profile; APIs will reject if the session is gone */
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const role = checkFunciton() || userRole;

  if (location.pathname === "/set-password") {
    return <AuthRouter updatedUser={updateuser} />;
  }

  return (
    <>
      {role === "ADMIN" || role === "SUBADMIN" ? (
        <AdminRouter logoutUser={logoutUser} />
      ) : role === "COUPLE" ? (
        <CoupleRouter logoutUser={logoutUser} />
      ) : (
        <AuthRouter updatedUser={updateuser} />
      )}
    </>
  );
};

export default IndexRouter;
